import React from "react";
import ReactDOMServer from "react-dom/server";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAt, faBuilding, faCity, faHouseChimney } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "leaflet";
import { DivIcon } from "../../../components";
import { colorIcons } from "../../../enums";
import TargetMarker from "../../../assets/images/targetMarker.png";

// Base pour les icones
export const baseIcon = {
  iconSize: [16, 16],
  iconAnchor: [8, 16],
  popupAnchor: [0, -16],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
};

export const IconAt = ReactDOMServer.renderToString(<FontAwesomeIcon icon={faAt} />);

export const IconImb = ReactDOMServer.renderToString(<FontAwesomeIcon icon={faBuilding} />);

export const IconPavillon = ReactDOMServer.renderToString(
  <FontAwesomeIcon icon={faHouseChimney} />,
);

export const IconFtteMarker = new DivIcon({
  html: ReactDOMServer.renderToString(<FontAwesomeIcon icon={faCity} />),
  className: `ai-icon`,
  style: { color: colorIcons.deploye, fontSize: "0.8em" },
  ...baseIcon,
});

export const IconTarget = new Icon({
  iconUrl: TargetMarker,
  iconSize: [30, 30],
  iconAnchor: [15, 40],
  popupAnchor: [0, -30],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
});
